// 订单收款信息
import orderReceipt from './orderReceipt'
// 订单付款信息
import orderPayment from './orderPayment'

export default {
  mixins: [orderReceipt, orderPayment],
}
